import TalentContentContainer from '../layout/TalentContentContainer';
import styles from './TalentMessagesPage.module.css';
import MessagesView from '../../../shared/messages/MessagesView';

export default function TalentMessagesPage() {
  return (
    <div className={styles.wrapper}>
      <TalentContentContainer>
        <div className={styles.header}>
          <div className={styles.headerInner}>
            <h1 className={styles.pageTitle}>메시지</h1>
            <p className={styles.pageSubtitle}>캐스팅 제안과 대화 내역을 한곳에서 확인하세요.</p>
          </div>
        </div>
        <div className={styles.content}>
          {/* 수신 허용 토글은 제작사 전용이라 배우 화면에는 없다 */}
          <MessagesView />
        </div>
      </TalentContentContainer>
    </div>
  );
}
